var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05016 10.334H8.05016V7.56732H10.8335V6.56732H8.05016V3.66732H7.05016V6.56732H4.16683V7.56732H7.05016V10.334ZM7.50016 13.6673C6.58905 13.6673 5.72794 13.4923 4.91683 13.1423C4.10572 12.7923 3.39738 12.3145 2.79183 11.709C2.18627 11.1034 1.7085 10.3951 1.3585 9.58398C1.0085 8.77287 0.833496 7.90621 0.833496 6.98398C0.833496 6.07287 1.0085 5.21176 1.3585 4.40065C1.7085 3.58954 2.18627 2.88398 2.79183 2.28398C3.39738 1.68398 4.10572 1.20898 4.91683 0.858984C5.72794 0.508984 6.59461 0.333984 7.51683 0.333984C8.42794 0.333984 9.28905 0.508984 10.1002 0.858984C10.9113 1.20898 11.6168 1.68398 12.2168 2.28398C12.8168 2.88398 13.2918 3.58954 13.6418 4.40065C13.9918 5.21176 14.1668 6.07843 14.1668 7.00065C14.1668 7.91176 13.9918 8.77287 13.6418 9.58398C13.2918 10.3951 12.8168 11.1034 12.2168 11.709C11.6168 12.3145 10.9113 12.7923 10.1002 13.1423C9.28905 13.4923 8.42238 13.6673 7.50016 13.6673Z",
    fill: "#1A2CCE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.f96bc2b5df715143829f31a321386130.svg";
export { ForwardRef as ReactComponent };